import { createContext, useContext, useState } from "react";

const FollowContext = createContext();

export const FollowProvider = ({ children }) => {
  const [followStates, setFollowStates] = useState({});

  const setFollowState = (userId, isFollowing) => {
    setFollowStates((prev) => ({
      ...prev,
      [userId]: isFollowing,
    }));
  };

  return (
    <FollowContext.Provider value={{ followStates, setFollowState }}>
      {children}
    </FollowContext.Provider>
  );
};

export const useFollow = () => useContext(FollowContext);
